// extracted by mini-css-extract-plugin
export default {"container":"y7uNdQzaRJQFym41TJBq","inverted":"HhY8Jz5yZcqHPFdkpqjU","accountName":"hng_6FUaZilkLNO3S5Eb","copyIcon":"BMlErUCcRoNC8YILHQMQ","rtl":"xjbmNJFnDIjv0elIsZON"};